import type { Feature, FeatureCollection } from 'geojson';
import { LngLat } from 'maplibre-gl'

export function BlockLines() {
    const lines : Feature[] = [];

    for (let lat = -90; lat <= 90; lat += 0.01) {
        const start: LngLat = new LngLat(-180, lat)
        const end: LngLat = new LngLat(180, lat)
        lines.push(
            {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: [[start.lng, start.lat], [end.lng, end.lat]]
                }
            }
        )
    }


    for (let long = -180; long <= 180; long += 0.01) {
        const start: LngLat = new LngLat(long, -90)
        const end: LngLat = new LngLat(long, 90)

        lines.push(
            {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: [[start.lng, start.lat], [end.lng, end.lat]]
                }
            }
        )
    }

    const blocksGeo: FeatureCollection = {
        type: 'FeatureCollection',
        features: lines
    };

    return blocksGeo
}

